import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from "@angular/core";
import { CommonModule } from '@angular/common';
import { LoadingService } from '@app/core/services/loading.service';

@Component({
  selector: "app-loading",
  imports: [CommonModule],
  templateUrl: "./loading.component.html",
  standalone: true,
  styleUrls: ["./loading.component.scss"],


})
export class LoadingComponent implements OnInit {
  isLoadingApi$ = this.loadingService.isLoadingApi$;
  constructor(private readonly loadingService: LoadingService) {}

  ngOnInit(): void {}
}
